import {MenuOutlined} from "@ant-design/icons";
import "./style.less"

const ToggleDrawerButton = ({onClick}: { onClick: () => void }) => (
  <div className="mobile-drawer-toggle" onClick={onClick} role="button" aria-label="Відкрити меню" tabIndex={0}
       onKeyDown={(e) => {
         if (e.key === 'Enter' || e.key === ' ') onClick();
       }}>
    <MenuOutlined/>
  </div>
);

export default ToggleDrawerButton
